import PropTypes from "prop-types";
import React, { useState, useRef } from "react";
import ImageWithBasePath from "core/img/imagewithbasebath";
import { Link, useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "react-feather";
import { useResetPasswordMutation } from "AppQuries/login/forgot-password";
import { toast } from "core/Operations/toast";
// import { all_routes } from "Router/all_routes";
// import { useResetPasswordMutation } from "AppQuries/login/forgot-password";
// import { toast } from "core/Operations/toast";

const ResetPassword = ({ userDetails }) => {
  const newPasswordRef = useRef();
  const confirmPasswordRef = useRef();
  const [passwordMatchMsg, setPasswordMatchMsg] = useState("");
  const [isPasswordMatch, setIsPasswordMatch] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [isValidEmail, setIsValidEmail] = useState();
  const [emailVeificationMsg, setEmailVeificationMsg] = useState("");
  const { mutate: resetPasswordMutate, isPending: isPasswordReseting } =
    useResetPasswordMutation();

  const navigate = useNavigate();

  const checkPasswordMatch = () => {
    console.log(newPasswordRef.current?.value);
    console.log(confirmPasswordRef.current?.value);
    if (newPasswordRef.current?.value === confirmPasswordRef.current?.value) {
      setPasswordMatchMsg("Passwords match");
      setIsPasswordMatch(true);
    } else {
      setPasswordMatchMsg("Passwords do not match");
      setIsPasswordMatch(false);
    }
  };

  const changePasswordHandler = () => {
    if (isPasswordMatch) {
      resetPasswordHandler({ password: newPasswordRef.current.value });
    } else {
      setPasswordMatchMsg("Passwords do not match");
    }
  };

  const resetPasswordHandler = ({ password }) => {
    console.log(userDetails);
    const payload = [
      {
        userID: userDetails?.[0].userID,
        userName: userDetails?.[0].userName,
        password: password,
        userGroupCode: "",
        emailId: userDetails?.[0].emailId,
        isActive: true,
        createUser: "",
        createDate: userDetails?.[0].createDate,
        modifyUser: "",
        modifyDate: userDetails?.[0].createDate,
        companyCode: userDetails?.[0].companyCode,
        lastLoginLocation: "",
        locationCode: "",
        isLock: false,
      },
    ];
    resetPasswordMutate(payload, {
      onSuccess: (data) => {
        if (data === true) {
          toast.success("Password Reset Successfully.");
          navigate("/Login");
        } else {
          toast.warning(data[0].errorMessage);
        }
      },
    });
  };

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper login-new">
          <div className="container">
            <div className="login-content user-login">
              <div className="login-logo">
                <ImageWithBasePath src="assets/img/logo.png" alt="img" />
                <Link to="#" className="login-logo logo-white">
                  <ImageWithBasePath src="assets/img/logo-white.png" alt />
                </Link>
              </div>

              <div className="login-userset">
                <form className="needs-validation digit-group">
                  <div className="login-userheading">
                    <h3>Change Password</h3>
                    {/* <h4>
                    If you forgot your password, well, then we’ll email you
                    instructions to reset your password.
                  </h4> */}
                  </div>
                  <div className="row form-row form-login">
                    <div className="col-12">
                      <label>New Password</label>
                      <div className="pass-group form-addons">
                        <input
                          name="password"
                          type={showPassword ? "text" : "password"}
                          className={`form-control `}
                          ref={newPasswordRef}
                          onChange={checkPasswordMatch}
                        />
                        <span
                          onClick={() => setShowPassword((prev) => !prev)}
                          className={`fas toggle-password ${
                            showPassword ? "fa-eye" : "fa-eye-slash"
                          }`}
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <label>Confirm Password</label>

                      <div className="pass-group form-addons">
                        <input
                          name="confirmPassword"
                          type={showPassword ? "text" : "password"}
                          className={`form-control `}
                          ref={confirmPasswordRef}
                          onChange={checkPasswordMatch}
                        />
                        <span
                          onClick={() => setShowPassword((prev) => !prev)}
                          className={`fas toggle-password ${
                            showPassword ? "fa-eye" : "fa-eye-slash"
                          }`}
                        />
                      </div>
                      <div
                        style={{
                          color:
                            isPasswordMatch === true
                              ? "green"
                              : isPasswordMatch === false
                              ? "red"
                              : "black",
                        }}
                      >
                        {passwordMatchMsg}
                      </div>
                    </div>

                    <button
                      onClick={changePasswordHandler}
                      className="btn btn-login"
                      type="button"
                      disabled={!isPasswordMatch || isPasswordReseting}
                    >
                      {isPasswordReseting ? (
                        <>
                          <i className="fas fa-spinner fa-spin me-2"></i>
                          Updating...
                        </>
                      ) : (
                        <>Change Password</>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
              <p>Copyright © 2024 WINHRMS. All rights reserved</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;

ResetPassword.propTypes = {
  userDetails: PropTypes.array.isRequired,
  //   resetPasswordHandler: PropTypes.func.isRequired,
};
